import { Fab, Paper, keyframes, styled } from "@mui/material";

const wavingEffect = keyframes`
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(14deg);
  }
  20% {
    transform: rotate(-8deg);
  }
  30% {
    transform: rotate(14deg);
  }
  40% {
    transform: rotate(-4deg);
  }
  50% {
    transform: rotate(10deg);
  }
  60% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const PREFIX = "StonlyPaper";
export const classes = {
  root: `${PREFIX}-root`,
};

export const StonlyPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: "absolute",
    right: theme.spacing(4),
    bottom: `calc(${theme.spacing(2)} + 45px + ${theme.spacing(2)})`,
    height: `calc(100% - ${theme.spacing(2)} - 45px - ${theme.spacing(2)} - ${theme.spacing(2)})`,
    width: "35%",
    zIndex: 10000,
  },
}));

const PREFIX_FAB = "StonlyFab";
export const classesFab = {
  root: `${PREFIX_FAB}-root`,
  icon: `${PREFIX_FAB}-icon`,
  wavingIcon: `${PREFIX_FAB}-wavingIcon`,
};

export const StonlyFab = styled(Fab)(({ theme }) => ({
  [`&.${classesFab.root}`]: {
    position: "absolute",
    right: theme.spacing(4),
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.fab,
    width: "45px",
    height: "45px",
  },
  [`& .${classesFab.icon}`]: {
    width: "24px",
    height: "24px",
  },
  [`& .${classesFab.wavingIcon}`]: {
    width: "24px",
    height: "24px",
    animationName: wavingEffect,
    animationDuration: "2.5s",
    animationIterationCount: 3,
  },
}));
